import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import ToDateNotificator from 'components/ToDateNotificator';
import { formatOrder } from 'components/CodeInfo';
import CodeInfoSection from 'components/CodeInfoSection';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoImportDuty extends Component {

    render() {
        const { duties } = this.props;
        const summary = getTitleSummary(duties)
        return (
            <CodeInfoSection
                title={{
                    headers: ['Импортная пошлина'],
                    rows: summary
                }}
                expanded={(duties.length !== 0) ? true : false}
                table={{
                    headers: [
                        '',
                        'Страна происхождения',
                        'Cтрана таможенной очистки',
                        'Ставка',
                        'Нормативный документ',
                        'Комментарий'
                    ],
                    rows: duties.map((
                        {
                            to_date = null,
                            joined_origin_country = '',
                            customs_clearance_country = '',
                            hint = '',
                            order,
                            order_date,
                            orders_info,
                            description = ''
                        }) => ([
                            <ToDateNotificator to_date={to_date} />,
                            joined_origin_country,
                            customs_clearance_country,
                            hint,
                            formatOrder(order, order_date, orders_info),
                            description
                        ]))
                }}
            />
        );
    }
}

function getTitleSummary(items) {
    return items.length > 0 ? items.slice(0, 1).map(({hint = '',order, order_date, orders_info, }) => 
    ([`${hint}` + (items.length > 1 ? ' (базовая ставка)' : ''), formatOrder(order, order_date, orders_info)])) : null
}





// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoImportDuty.js